<template>
  <!-- CONTENT -->
  <div
    :id="'screen'"
    :style="{opacity: opacity}"
  >
    <!-- Background -->
    <Background />

    <!-- Header -->
    <Header
      title="Create invoice"
      :showGoBack="true"
    />

    <!-- Main content -->
    <main
      class="scrollable container"
      :style="{paddingTop: '10px', paddingBottom: '20px'}"
    >
      <Input
        :leftIcon="UserSvg"
        :placeholder="'Company name'"
        :containerStyle="{marginBottom: '10px'}"
      />
      <Input
        :leftIcon="MapPinSvg"
        :placeholder="'Country'"
        :containerStyle="{marginBottom: '10px'}"
      />
      <Input
        :leftIcon="MailSvg"
        :placeholder="'Company email'"
        :containerStyle="{marginBottom: '10px'}"
      />
      <Input
        :leftIcon="DollarSvg"
        :placeholder="'Amount'"
        :containerStyle="{marginBottom: '30px'}"
      />

      <!-- Currencies -->
      <section :style="{marginBottom: '30px'}">
        <ul
          class="row-center"
          :style="{gap: '11px'}"
        >
          <li
            v-for="currency in currencies"
            :key="currency"
            @click="selectedCurrency = currency"
            class="center"
            :style="{
              width: '100%',
              height: '30px',
              borderRadius: '6px',
              borderStyle: 'solid',
              borderWidth: '1px',
              borderColor:
                currency === selectedCurrency ? 'var(--main-dark)' : '#6C6D84',
              backgroundColor:
                currency === selectedCurrency
                  ? 'var(--main-dark)'
                  : 'var(--white-color)',
            }"
          >
            <span
              class="t14"
              :style="{
                color:
                  currency === selectedCurrency
                    ? 'var(--white-color)'
                    : 'var(--main-dark)',
              }"
            >
              {{ currency }}
            </span>
          </li>
        </ul>
      </section>
      <textarea
        :style="{
          marginBottom: '10px',
          width: '100%',
          height: '120px',
          borderRadius: '10px',
          border: '1px solid #FFEFE6',
          paddingLeft: '20px',
          paddingTop: '14px',
          paddingBottom: '14px',
          paddingRight: '20px',
          resize: 'none',
          fontSize: '16px',
          fontFamily: 'Source Sans Pro',
          backgroundColor: 'var(--white-color)',
        }"
        placeholder="Goods or services you provided"
      ></textarea>
      <span
        class="t14"
        :style="{marginBottom: '30px', display: 'block'}"
        >Bank fee is charged from the payer.</span
      >
      <Button
        :title="'Create invoice'"
        :onClick="() => $router.push(routes.INVOICE_SENT)"
      />
    </main>
  </div>
</template>

<script setup>
import {ref} from 'vue';
import {useOpacity} from '@/hooks';
import {routes} from '@/routes';

import {UserSvg} from '@/assets/svg';
import {MailSvg} from '@/assets/svg';
import {MapPinSvg} from '@/assets/svg';
import {DollarSvg} from '@/assets/svg';
import {Button} from '@/components';
import {Input} from '@/components';
import {Header} from '@/components';
import {Background} from '@/components';

const currencies = ['USD', 'EUR'];

const selectedCurrency = ref(currencies[0]);
const opacity = useOpacity();
</script>
